// src/components/CaseStudySection.js

import React from "react";
import { Container, Grid, Typography, Box } from "@mui/material";
import CaseStudyCard from "./CaseStudyCard"; // Import the card component
// import { caseStudies } from '../caseStudyData';
import { caseStudies } from "../utils/caseStudyData";

const CaseStudySection = () => {
  return (
    <Box sx={{ bgcolor: "background.paper", py: 8 }}>
      <Container maxWidth="lg">
        <Typography
          variant="h4"
          align="center"
          gutterBottom
          sx={{ fontSize: {
                lg: "2.4rem",
                md: "1.7rem",
                sm: "1.5rem",
                xs: "1.3rem",
              },fontWeight: 600, mb: 4 }}
          
        >
          Our Case Studies 
        </Typography>
        <Grid container spacing={4}>
          {caseStudies.map((study) => (
            <Grid item key={study.id} xs={12} sm={6} md={4}>
              <CaseStudyCard
                id={study.id} // Pass the ID
                clientName={study.clientName}
                shortDescription={study.shortDescription} // Pass the short description
                imageUrl={study.imageUrl}
              />
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};

export default CaseStudySection;
